<template>
    <div class="bax-banner-wrap">
        <div class="bax-banner-title-block" >
            <div class="container">
                <select class="user-switcher" v-if="(this.$router.currentRoute.path === '/') && (Object.keys(hospitalList).length > 1)" v-model="hospitalSelected">
                    <option value="0">Change Hospital</option>
                    <option v-for="(item, key) in hospitalList" v-bind:key="key" :value="key">
                        {{item}}
                    </option>
                </select>
                <div class="bax-banner-title d-md-flex align-items-center">
                    <h6 class="d-flex align-items-center"><img src="@/assets/images/login-img.png" alt="Welcome">{{user.hospitalName}}</h6>
                    <strong class="ml-auto mt-1 mt-md-0 text-center text-md-left d-block d-md-inline-block" v-if="order">Order Ref: {{ order.orderRefView?order.orderRefView:order.orderRef }}</strong>
                </div>
            </div>
        </div>
        <div class="bax-banner-content d-flex align-items-end" v-if="!orderStep && !headingMain">
            <div class="container">
                <h1 class="d-flex align-items-center">Welcome {{ user.firstName }} {{ user.lastName }}</h1>
            </div>
        </div>
        <csv-order-steps v-if="orderStep && (orderStep < 6)" :active="orderStep" />
        <div class="bax-banner-content d-flex align-items-end" v-if="headingMain">
            <div class="container">
                <h1 :class="hasBackButton?'d-flex align-items-center':''">
                    <a href="#" @click.prevent="$emit('goBack');" class="bax-back-btn" v-if="hasBackButton">
                        <i class="icon-arrow-left d-flex justify-content-center align-items-center"></i>
                    </a>
                    {{ headingMain }}</h1>
                <p v-if="headingSub">{{ headingSub }}</p>
            </div>
        </div>
    </div>
</template>

<script>

    import CsvOrderSteps from '@/views/Order/CsvOrderSteps.vue';
    import User from '@/core/api/auth/User.class';

    export default {
        name: 'BaxHeaderBannerWide',
        components: {
            CsvOrderSteps,
        },
        props: {
            user: {
                required: true,
            },
            order: {
                required: false,
            },
            orderStep: {
                required: false,
            },
            headingMain: {
                required: false,
            },
            headingSub: {
                required: false,
            },
            bacBtnFunc: {
                required: false,
            },
        },
        data() {
            return {
                hasBackButton: false,
                hospitalList: [],
                hospitalSelected: 0,
            };
        },
        mounted() {
        },
        created() {
            this.hasBackButton = this.$listeners && this.$listeners.goBack;

           this.hospitalList = this.user.hospitalList;
        },
        watch: {
            hospitalSelected(val) {
                User.updateHospital(val).then(() => {
                    window.location.reload();
                });
            },
        },
    };
</script>
